import { tenantApi as api } from '../config/api'
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    listCourses: build.query<ListCoursesApiResponse, ListCoursesApiArg>({
      query: (queryArg) => ({
        url: `/courses/`,
        params: {
          query: queryArg.query,
          page: queryArg.page,
          size: queryArg.size,
        },
      }),
    }),
    createCourse: build.mutation<CreateCourseApiResponse, CreateCourseApiArg>({
      query: (queryArg) => ({ url: `/courses/`, method: 'POST', body: queryArg.createCourseDto }),
    }),
    deleteCourseByCode: build.mutation<DeleteCourseByCodeApiResponse, DeleteCourseByCodeApiArg>({
      query: (queryArg) => ({ url: `/courses/${queryArg.courseCode}`, method: 'DELETE' }),
    }),
    getCourseByCode: build.query<GetCourseByCodeApiResponse, GetCourseByCodeApiArg>({
      query: (queryArg) => ({ url: `/courses/${queryArg.courseCode}` }),
    }),
    updateCourseByCode: build.mutation<UpdateCourseByCodeApiResponse, UpdateCourseByCodeApiArg>({
      query: (queryArg) => ({ url: `/courses/${queryArg.courseCode}`, method: 'PUT', body: queryArg.updateCourseDto }),
    }),
    listCourseVariants: build.query<ListCourseVariantsApiResponse, ListCourseVariantsApiArg>({
      query: (queryArg) => ({ url: `/courses/${queryArg.courseCode}/course_variants` }),
    }),
    createCourseVariant: build.mutation<CreateCourseVariantApiResponse, CreateCourseVariantApiArg>({
      query: (queryArg) => ({
        url: `/courses/${queryArg.courseCode}/course_variants`,
        method: 'POST',
        body: queryArg.createCourseVariantDto,
      }),
    }),
    syncLmdhCourseVariants: build.mutation<SyncLmdhCourseVariantsApiResponse, SyncLmdhCourseVariantsApiArg>({
      query: (queryArg) => ({ url: `/courses/${queryArg.courseCode}/course_variants/sync/lmdh`, method: 'PUT' }),
    }),
    deleteCourseVariant: build.mutation<DeleteCourseVariantApiResponse, DeleteCourseVariantApiArg>({
      query: (queryArg) => ({
        url: `/courses/${queryArg.courseCode}/course_variants/${queryArg.courseVariantId}`,
        method: 'DELETE',
      }),
    }),
    getCourseVariantById: build.query<GetCourseVariantByIdApiResponse, GetCourseVariantByIdApiArg>({
      query: (queryArg) => ({ url: `/courses/${queryArg.courseCode}/course_variants/${queryArg.courseVariantId}` }),
    }),
    updateCourseVariant: build.mutation<UpdateCourseVariantApiResponse, UpdateCourseVariantApiArg>({
      query: (queryArg) => ({
        url: `/courses/${queryArg.courseCode}/course_variants/${queryArg.courseVariantId}`,
        method: 'PUT',
        body: queryArg.updateCourseVariantDto,
      }),
    }),
  }),
  overrideExisting: false,
})
export { injectedRtkApi as enhancedApi }
export type ListCoursesApiResponse = /** status 200 Successful Response */ PageCourseDto
export type ListCoursesApiArg = {
  query?: string
  page?: number
  size?: number
}
export type CreateCourseApiResponse = /** status 201 Successful Response */ CourseDto
export type CreateCourseApiArg = {
  createCourseDto: CreateCourseDto
}
export type DeleteCourseByCodeApiResponse = unknown
export type DeleteCourseByCodeApiArg = {
  courseCode: string
}
export type GetCourseByCodeApiResponse = /** status 200 Successful Response */ CourseDto
export type GetCourseByCodeApiArg = {
  courseCode: string
}
export type UpdateCourseByCodeApiResponse = /** status 200 Successful Response */ CourseDto
export type UpdateCourseByCodeApiArg = {
  courseCode: string
  updateCourseDto: UpdateCourseDto
}
export type ListCourseVariantsApiResponse = /** status 200 Successful Response */ CourseVariantDto[]
export type ListCourseVariantsApiArg = {
  courseCode: string
}
export type CreateCourseVariantApiResponse = /** status 201 Successful Response */ CourseVariantDto
export type CreateCourseVariantApiArg = {
  courseCode: string
  createCourseVariantDto: CreateCourseVariantDto
}
export type SyncLmdhCourseVariantsApiResponse = /** status 200 Successful Response */ CourseVariantSyncResultDto
export type SyncLmdhCourseVariantsApiArg = {
  courseCode: string
}
export type DeleteCourseVariantApiResponse = unknown
export type DeleteCourseVariantApiArg = {
  courseVariantId: string
  courseCode: string
}
export type GetCourseVariantByIdApiResponse = /** status 200 Successful Response */ CourseVariantDto
export type GetCourseVariantByIdApiArg = {
  courseVariantId: string
  courseCode: string
}
export type UpdateCourseVariantApiResponse = /** status 200 Successful Response */ CourseVariantDto
export type UpdateCourseVariantApiArg = {
  courseVariantId: string
  courseCode: string
  updateCourseVariantDto: UpdateCourseVariantDto
}
export type CourseAccessibilityEnum = 'AA-WCAG 2.1'
export type CourseDto = {
  accessibility?: CourseAccessibilityEnum
  code: string
  created_at?: string
  duration_in_minutes: number
  id: string
  lmdh_elearning_content_guid?: string
  name: string
  no_of_variants: number
  salesforce_id?: string
  updated_at?: string
}
export type PageCourseDto = {
  items: CourseDto[]
  page?: number
  pages?: number
  size?: number
  total?: number
}
export type ValidationError = {
  loc: (string | number)[]
  msg: string
  type: string
}
export type HttpValidationError = {
  detail?: ValidationError[]
}
export type CourseSource = 'LMDH'
export type CreateCourseDto = {
  accessibility?: CourseAccessibilityEnum
  code: string
  duration_in_minutes: number
  lmdh_elearning_content_guid?: string
  name: string
  salesforce_id: string
  source: CourseSource
}
export type UpdateCourseDto = {
  accessibility?: CourseAccessibilityEnum
  code: string
  duration_in_minutes: number
  lmdh_elearning_content_guid?: string
  name: string
  salesforce_id: string
  source: CourseSource
}
export type FormOfAddress = 'formal' | 'informal' | 'not_applicable'
export type CourseVariantDto = {
  created_at?: string
  description: string
  easy_language: boolean
  form_of_address: FormOfAddress
  id: string
  language_display_name: string
  language_tag: string
  learning_objectives: string[]
  low_vision: boolean
  tenant_id?: string
  tenant_name?: string
  title: string
  updated_at?: string
  wcag: boolean
}
export type CreateCourseVariantDto = {
  description: string
  easy_language: boolean
  form_of_address: FormOfAddress
  language_tag: string
  learning_objectives: string[]
  low_vision: boolean
  tenant_id?: string
  title: string
  wcag: boolean
}
export type CourseVariantSyncResultDto = {
  archived: number
  created: number
  errors: string[]
  updated: number
}
export type UpdateCourseVariantDto = {
  description: string
  easy_language: boolean
  form_of_address: FormOfAddress
  language_tag: string
  learning_objectives: string[]
  low_vision: boolean
  tenant_id?: string
  title: string
  wcag: boolean
}
export const {
  useListCoursesQuery,
  useCreateCourseMutation,
  useDeleteCourseByCodeMutation,
  useGetCourseByCodeQuery,
  useUpdateCourseByCodeMutation,
  useListCourseVariantsQuery,
  useCreateCourseVariantMutation,
  useSyncLmdhCourseVariantsMutation,
  useDeleteCourseVariantMutation,
  useGetCourseVariantByIdQuery,
  useUpdateCourseVariantMutation,
} = injectedRtkApi
